var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "button",
        {
          staticClass: "button",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              _vm.showingModal = true
            }
          }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("span", [_vm._v("Add " + _vm._s(_vm.contactType))])
        ]
      ),
      _vm._v(" "),
      _vm.showingModal
        ? _c(
            "modal",
            {
              attrs: { title: _vm.title, width: "800px", "full-height": "" },
              on: {
                close: function($event) {
                  _vm.showingModal = false
                }
              }
            },
            [
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "label" }, [_vm._v("Name")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "control" },
                  [
                    _c(
                      "multiselect",
                      {
                        attrs: {
                          options: _vm.availableCompanies,
                          searchable: true,
                          label: "name",
                          "track-by": "id",
                          placeholder: "Start typing to search companies"
                        },
                        on: {
                          "search-change": _vm.fetchAvailableCompanies,
                          select: _vm.getDetails,
                          remove: function($event) {
                            _vm.companyDetails = {}
                          }
                        },
                        model: {
                          value: _vm.selectedCompany,
                          callback: function($$v) {
                            _vm.selectedCompany = $$v
                          },
                          expression: "selectedCompany"
                        }
                      },
                      [
                        _c("template", { slot: "noResult" }, [
                          _vm._v("No companies found.\n            "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  _vm.maxxIntranetDomain +
                                  "/membership/CompanyFormPrivate/edit",
                                target: "_blank"
                              }
                            },
                            [
                              _vm._v(
                                "Click here to add a company to the database."
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("template", { slot: "noOptions" }, [
                          _c("div", { staticClass: "help" }, [
                            _vm._v(
                              "\n              Can't find the company?\n              "
                            ),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    _vm.maxxIntranetDomain +
                                    "/membership/CompanyFormPrivate/edit",
                                  target: "_blank"
                                }
                              },
                              [_vm._v("Click here to add it to the database.")]
                            )
                          ])
                        ])
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "help" }, [
                      _vm._v("\n          Can't find the company?\n          "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              _vm.maxxIntranetDomain +
                              "/membership/CompanyFormPrivate/edit",
                            target: "_blank"
                          }
                        },
                        [_vm._v("Click here to add it to the database.")]
                      )
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.noMaxxUser
                ? _c(
                    "b-notification",
                    {
                      staticClass: "is-small",
                      attrs: {
                        type: "is-danger",
                        "has-icon": "",
                        closable: false,
                        role: "alert"
                      }
                    },
                    [
                      _vm._v(
                        "\n      You are not logged in as a MatrixMaxx user. Please login to fix this\n      problem.\n    "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.companyDetails.name
                ? _c("h2", { staticClass: "title is-3" }, [
                    _vm._v(
                      "\n      " + _vm._s(_vm.companyDetails.name) + "\n    "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.companyDetails.name,
                      expression: "companyDetails.name"
                    }
                  ],
                  staticClass: "columns"
                },
                [
                  _c("div", { staticClass: "column is-3" }, [
                    _c("div", { staticClass: "field" }, [
                      _c(
                        "label",
                        { staticClass: "image is-150x150 show-icon-hover" },
                        [
                          _c(
                            "span",
                            { staticClass: "icon icon-right is-medium" },
                            [
                              _c("i", {
                                staticClass: "fas fa-pen-square fa-2x"
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _vm.companyDetails
                            ? _c("img", {
                                staticStyle: { display: "block" },
                                attrs: {
                                  src:
                                    _vm.fixHttpProtocol(
                                      _vm.companyDetails.logo_path
                                    ) || "/static/150x150.png"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("input", {
                            staticStyle: { display: "none" },
                            attrs: { type: "file" }
                          })
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("div", { staticClass: "label" }, [
                        _vm._v("Description")
                      ]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.companyDetails.description,
                            expression: "companyDetails.description"
                          }
                        ],
                        staticClass: "textarea",
                        domProps: { value: _vm.companyDetails.description },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.companyDetails,
                              "description",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-success",
                    class: { "is-loading": _vm.loading },
                    on: { click: _vm.saveSuite }
                  },
                  [
                    _vm._v(
                      "\n        Add " + _vm._s(_vm.contactType) + "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  { staticClass: "button", on: { click: _vm.close } },
                  [_vm._v("Cancel")]
                )
              ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "fa fa-plus" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10d8192c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10d8192c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ModalAddSuite.vue
// module id = null
// module chunks = 